<ul *ngIf="hasActiveBreadcrumbs" class="breadcrumb container-wrapper container-wrapper-breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs" [class.active]="breadcrumb.isActive">
      <a *ngIf="breadcrumb.isActive" [routerLink]="breadcrumb.url">
        {{ breadcrumb.label | translate }}
      </a>
      <a *ngIf="!breadcrumb.isActive">
        {{ breadcrumb.label | translate }}
      </a>
    </li>
  </ul>
